var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogonavbarexis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.67,365.21v30h-7.08V387.9c0-7.12.26-10.64.22-10.64h-.05s-2.44,4.12-2.7,4.55l-3.52,6h-3.73l-3.51-6c-.26-.43-2.66-4.55-2.7-4.55h0s.22,3.52.22,10.64v7.33h-7.08v-30h6.78l5.61,9.09c2.19,3.56,2.54,4.33,2.58,4.33h0s.39-.77,2.57-4.33l5.62-9.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.47,364.61a15.61,15.61,0,1,1-15.56,15.61A15.34,15.34,0,0,1,260.47,364.61Zm0,24.1c4.89,0,8.11-3.47,8.11-8.49s-3.22-8.49-8.11-8.49-8.06,3.43-8.06,8.49S255.63,388.71,260.47,388.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.36,365.21c5.36,0,9.09,3.56,9.09,7.93a6.46,6.46,0,0,1-3.73,5.88v0a7.83,7.83,0,0,1,5.27,7.08c0,5-3.3,9.09-10.72,9.09H306.32v-30Zm-1.5,11.71c1.93,0,3.34-1.2,3.34-2.83s-1.41-2.83-3.34-2.83h-4.33v5.66Zm.68,12.26c2.4,0,3.91-1.41,3.91-3.38s-1.63-3.39-3.91-3.39h-5v6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.36,395.23v-30h7.2v30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.39,388.5v6.73H400v-30h7.2V388.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.32,395.23v-30h7.21v30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.38,365.21v6.73h-9.13v23.29H497V371.94h-9v-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.84,365.21l-11.5,16.73v13.29h-7.16V381.94l-11.49-16.73h8.06l5.45,8a24.63,24.63,0,0,0,1.54,2.19h0a25.87,25.87,0,0,0,1.55-2.19l5.44-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.34,215l.43-.62H385.54L366.61,242.6c-.89,1.43-2.57,4.44-4.06,7.11-1,1.81-2.05,3.67-2.48,4.38-.5-.79-1.76-3-2.89-5-1.4-2.45-3-5.22-3.83-6.55l-18.93-28.21h-30l40.49,59.78-42.93,62.92H331.8l19.63-27.87c1.1-1.64,3.39-5.45,5.41-8.81,1.34-2.22,2.71-4.51,3.23-5.3.48.75,1.7,2.83,2.89,4.86,2,3.36,4.43,7.54,5.58,9.26l19.62,27.86H418l-42.94-62.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "435.69 337.08 460.69 311.93 460.69 214.38 435.69 214.38 435.69 337.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "283.44 285.01 283.44 262.96 209.59 262.96 209.59 237.81 283.44 237.81 283.44 214.38 212.5 214.38 184.58 242.29 184.58 337.08 283.44 337.08 283.44 313.64 209.59 313.64 209.59 285.01 283.44 285.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.54,264.21,530,262.67c-13-4.33-24.22-8.07-24.22-16.55,0-7.25,7.35-12.31,17.88-12.31,9.79,0,20.95,5.61,23.82,18.15l.07.31,18.78-18.78c-8.4-13.24-23.68-21.55-41.28-21.55-25.22,0-45,15.63-45,35.58,0,22.46,20.55,29.89,32.84,34.33,2.83,1,5.65,1.92,8.38,2.81,14,4.58,25.13,8.19,25.13,18.23,0,8.65-7.63,14.23-19.45,14.23a27.22,27.22,0,0,1-27.13-20.94l-.08-.34-18.92,18.92c9,15.89,24.87,24.76,45.09,24.76,27.71,0,47.07-15.49,47.07-37.67C573,280.29,553.53,270.72,534.54,264.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.86 248.54 51.81 259.62 130.84 259.62 141.89 248.54 62.86 248.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.4 333.51 105.43 333.51 116.48 322.44 37.46 322.44 26.4 333.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.25 285.56 64.19 296.64 93.2 296.64 104.25 285.56 75.25 285.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonavbarexis);
export default __webpack_public_path__ + "static/media/logonavbarexis.0efdf142d0ba9686289feb5275236104.svg";
export { ForwardRef as ReactComponent };